export enum UserGroupType {
  INDIVIDUAL,
  DOMAIN_NAME
}
